<template>
    <div class="family-health-history">
        <div class="d-flex p-2 mt-4">
            <h5 class="fw-bold my-auto">Family Health History</h5>
            <button
                type="button"
                class="btn btn-primary ms-auto"
                @click="openAddFamilyHistory()"
                v-if="!isAddRequested"
            >
                Add Family Health History
            </button>
        </div>
        <div
            v-if="isAddRequested"
            :class="`card px-lg-5 py-2 mb-2 w-100 h-100 animated ${
                isAddRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`"
        >
            <FamilyHistoryForm
                ref="familyHistoryForm"
                :is-save-in-progress="isSaving"
                :family-health-history="familyHealthHistory"
                :isEdit="false"
                :patient-relationship-enum="patientRelationshipEnum"
                :relation-status-enum="relationStatusEnum"
            />
            <div class="col-md-12 d-flex justify-content-center align-items-center pb-2 mt-2" v-if="!isSaving">
                <button type="button" class="btn btn-outline-primary btn-md" @click="cancelAddFamilyHistory()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary btn-md ms-2" @click="saveFamilyHistory()">Save</button>
                <button type="button" class="btn btn-primary btn-md ms-2" @click="saveFamilyHistory(true)">
                    Save and Add Another
                </button>
            </div>
        </div>

        <!-- LIST -->
        <Pagination ref="familyPaginationInstance" :page-changed="pageChangedCallback" :is-loading="isLoading">
            <table class="table table-responsive-md border border-gray">
                <thead>
                    <tr class="bg-table-header">
                        <th>Health Condition</th>
                        <th>Relationship to Patient</th>
                        <th>Age of Diagnosis</th>
                        <th>Status</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- LOADING -->
                    <tr v-if="isLoading" v-for="i of loadingCount" class="table-loading" :key="i">
                        <td v-for="i of columns">
                            <span class="shimmer-loading"></span>
                        </td>
                    </tr>
                    <!-- NO RESULTS -->
                    <tr v-if="!isLoading && !isError && !hasData" class="table-empty">
                        <td :colspan="columns">
                            <h3>No Family Health History to Display</h3>
                        </td>
                    </tr>
                    <!-- ERROR -->
                    <tr v-if="!isLoading && isError" class="table-error">
                        <td :colspan="columns">
                            <ErrorMessageHandler title="Family Health History" :try-again="reset" />
                        </td>
                    </tr>
                </tbody>
                <template v-if="!isLoading && !isError && hasData">
                    <FamilyHistoryRow
                        v-for="(familyHealthHistory, index) of page.Items"
                        :key="index"
                        :family-health-history="familyHealthHistory"
                        :columns="columns"
                        :page-reset="reset"
                        :patient-id="patientId"
                        :accountId="accountId"
                        v-model:current-edit-row-id="currentEditRowId"
                    />
                </template>
            </table>
        </Pagination>
    </div>
</template>

<style src="./FamilyHealthHistory.scss" />
<script lang="ts" src="./FamilyHealthHistory.ts" />
